// import external dependencies
//import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/_slick.js"; import "./autoload/_waypoints.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateFlexible from './routes/templateFlexible';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  templateFlexible,
});

var Promise = require("bluebird");

window.loaded = new Promise((resolve, reject) => {
    window.addEventListener('load', () => resolve(window))
})

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js